module.exports = __webpack_public_path__ + "Icon-oceania.dbabaeb84cc2d20cc5293d5a4161b07a.svg";